<template>
    <div class="chain-base">
        <router-view/>
        <div v-if="$route.meta.footer.show" class='common-footer-wrap'>
            <mt-tabbar v-model='home_selected' fixed class="common-footer">
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeIndex'}" id='home_index'><router-link :to="{ name: 'HomeIndex'}" class='item'><img src="../../assets/image/chain/icon_home_seller_pre.png" class="image" v-if="$route.name=='HomeIndex'"><img v-else src="../../assets/image/chain/icon_home_seller_nor.png" class="image" /><span class='text'>返回商城</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='ChainOrderList'}" id='chain_order'><router-link :to="{ name: 'ChainOrderList'}" class='item'><img src="../../assets/image/chain/icon_list_seller_pre.png" class="image" v-if="$route.name=='ChainOrderList'"><img v-else src="../../assets/image/chain/icon_list_seller_nor.png" class="image" /><span class='text'>订单管理</span></router-link></mt-tab-item>
                <mt-tab-item class='item-wrap' :class="{'active':$route.name=='ChainIndex'}" id='chain_index'><router-link :to="{ name: 'ChainIndex'}" class='item'><img src="../../assets/image/chain/icon_mine_seller_pre.png" class="image" v-if="$route.name=='ChainIndex'"><img v-else src="../../assets/image/chain/icon_mine_seller_nor.png" class="image" /><span class='text'>门店中心</span></router-link></mt-tab-item>
            </mt-tabbar>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ChainBase',
  data () {
    return {
      home_selected: 'chain_index'
    }
  },
  computed: {
    ...mapState({
      user: state => state.chain.info
    })
  },
  created: function () {
    if (this.$route.name != 'ChainRegister' && this.$route.name != 'ChainLogin' && !this.user) {
      this.$router.push({ name: 'ChainLogin' })
    }
  }
}
</script>
<style lang="scss" scoped>
    .image{
        width:1rem;
        height:1rem;
        display:block;
        margin-left:auto;
        margin-right:auto;
        margin-top:.2rem;
        margin-bottom:.2rem;
    }
</style>
